import ResetPassword1Form from "../../forms/account/reset1";
import ResetPassword2Form from "../../forms/account/reset2";
import Logo from "../../icons/logo";
import { FloatingBlock } from "../../../styles/blocks";
import { H1 } from "../../../styles/type/headings";
import { AssistiveText } from "../../../styles/type/typography";

const ResetPassword = ({ userId = null, resetCode = null }) => (
	<FloatingBlock>
		<H1 small>{userId ? "reset password" : "forgot username/ password"}.</H1>
		<Logo />
		<AssistiveText pushTop>
			{userId ? "Reset your account password using the form below." : "Enter your email address to request login details and/ or begin resetting your password."}
		</AssistiveText>
		{userId ? <ResetPassword2Form userId={userId} resetCode={resetCode} /> : <ResetPassword1Form />}
	</FloatingBlock>
);

export default ResetPassword;
